/* eslint eqeqeq: "off" */
/*eslint no-useless-concat: "off"*/
import React, { useState, useEffect } from 'react';
import {
  Drawer,
  Menu,
  Dropdown,
  Button,
  Row,
  Col,
  Form,
  DatePicker,
  TimePicker,
  Spin,
  Popover,
  Checkbox,
  Input,
  Tag,
  Table,
} from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import useWindowSize from '../../../components/windowdimensions/windowSize';
import { create } from '../../../services/event.service';
import { getMenuListForEvents, getEventParticipants } from '../DashboardUtils';
import { cloneDeep, includes, remove } from 'lodash';
import { SketchPicker } from 'react-color';
import { searchMenuCategories } from '../../../services/category.service';
import { getAllStationOperators } from '../../../services/station.service';
import { searchMenu, activateEventChecklist, batchCourses } from '../../../services/menu.service';
import { batchRecipes } from '../../../services/course.service';
import { REACT_APP_SOCKET_BASE_URL } from '../../../config';
import openSocket from 'socket.io-client';
import {
  FolderIcon,
  CompletionIcon,
  MeetingParticipantAdd,
  CidekicButton as LinkButton,
} from '../../../components/common/common_ui';

const format = 'h:mm A';
const dateFormat = 'MM / DD / YYYY';
const daysOfWeek = ['Monday', 'Friday', 'Tuesday', 'Saturday', 'Wednesday', 'Sunday', 'Thursday'];

const AddEventDrawerV2 = (props) => {
  const {
    showDrawer,
    setShowDrawer,
    type,
    addedEvent,
    form: { getFieldDecorator },
  } = props;

  const [isSubmitting, setSubmitting] = useState(false);
  const [eventName, setEventName] = useState('');
  const [eventStartDate, setEventStartDate] = useState(moment());
  const [eventEndDate, setEventEndDate] = useState(moment());
  const [start, setStart] = useState(moment('00:00', format).format(format));
  const [end, setEnd] = useState(moment('00:00', format).format(format));
  const [repeatUntil, setUntil] = useState();
  const [eventMenus, setEventMenus] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [eventColor, setEventColor] = useState('#FF59CE');
  const [participants, setEventParticipants] = useState([]);
  const [operatorsToChoose, setOperatorsToChoose] = useState([]);
  const [locationOperators, setLocationOperators] = useState([]);
  const [selectedCustomDays, setSelectedCustomDays] = useState([]);
  const [searchedParticipant, setSearchedParticipant] = useState('');
  const [guest, setGuest] = useState(0);
  const [repeat, setRepeat] = useState({ name: 'never', label: 'Never' });
  const [eventDescription, setEventDescription] = useState('');
  const [menus, setMenus] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [showMenus, setShowMenus] = useState(false);
  const [eventSocket] = useState(() => openSocket(`${REACT_APP_SOCKET_BASE_URL}/event`));
  const [catgUpdate, setCatgUpdate] = useState([]);
  const [catgAdd, setCatgAdd] = useState([]);
  const [catgDelete, setCatgDelete] = useState('');
  const [eventSocket2] = useState(() => openSocket(`${REACT_APP_SOCKET_BASE_URL}/menu`));

  const restoInfo = JSON.parse(localStorage.getItem('restaurant')) || {};

  const { TextArea } = Input;

  const resetForm = () => {
    setEventName('');
    setEventDescription('');
    setEventStartDate(moment());
    setEventEndDate(moment());
    setUntil(moment());
    setRepeat({ name: 'never', label: 'Never' });
    setEventParticipants([]);
    setSelectedCustomDays([]);
    setEventColor('#FF59CE');
    setStart(moment('00:00', format).format(format));
    setEnd(moment('00:00', format).format(format));
    setEventMenus([]);
    setGuest(0);
    setSearchedParticipant('');
    setRepeat({ name: 'never', label: 'Never' });
    setShowMenus(false);
    props.form.setFieldsValue({
      title: '',
    });
  };

  useEffect(() => {
    if (locationOperators.length === 0) {
      getAllStationOperators(restoInfo.id).then((res) => {
        setLocationOperators(res);
      });
    }
    getCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (locationOperators.length > 0) {
      getEventParticipants(locationOperators, setOperatorsToChoose);
    }
  }, [locationOperators]);

  useEffect(() => {
    if (showDrawer && type === 'event') {
      getMenuListForEvents(setMenuList);
      console.log(menuList);
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDrawer, type, setMenuList]);

  useEffect(() => {
    if (searchedParticipant !== '') {
      getEventParticipants(locationOperators, setOperatorsToChoose, participants);
    } else {
      if (locationOperators.length > 0) {
        setOperatorsToChoose(locationOperators);
      }
    }
  }, [searchedParticipant, locationOperators, participants]);

  const windowSize = useWindowSize();

  useEffect(() => {
    console.log(windowSize);
  }, [windowSize]);

  useEffect(() => {
    console.log(eventMenus);
  }, [eventMenus]);

  const handleAddParticipant = (operator) => {
    const clonedParticip = cloneDeep(participants);
    clonedParticip.push(operator);
    setEventParticipants(clonedParticip);
    setSearchedParticipant('');
  };

  useEffect(() => {
    if (participants?.length > 0) {
      getEventParticipants(locationOperators, setOperatorsToChoose, participants);
    }
  }, [participants, locationOperators]);

  const checkIfDaySelected = (dayName) => {
    // for form control
    return includes(selectedCustomDays, dayName);
  };

  const handleAddCustomDay = (dayName) => {
    const cloneCustomDays = cloneDeep(selectedCustomDays);
    if (checkIfDaySelected(dayName)) {
      // have to remove
      remove(cloneCustomDays, (day) => {
        return day === dayName;
      });
    } else {
      cloneCustomDays.push(dayName);
    }
    setSelectedCustomDays(cloneCustomDays);
  };
  // const availableOperators = (() => {
  //   // don't render selected participants
  // 	// CHANGE 1202077200318274
  // 	if (operatorsToChoose.length > 0) {
  // 		let clonedOperators = cloneDeep(operatorsToChoose);
  // 		let available = [];
  // 		for (let i = 0; i < clonedOperators.length; i++) {
  // 			let isExisting = find(participants, { id: clonedOperators[i].id });
  // 			if (!isExisting) {
  // 				available.push(clonedOperators[i]);
  // 			}
  // 		}
  // 		return available;
  // 	}
  // 	return [];
  // })();

  // CHANGE 1202077200318274
  const onClickRemoveParticipant = () => {
    setSearchedParticipant('');
    getEventParticipants(locationOperators, setOperatorsToChoose, participants);
    // setOperatorsToChoose([]);
  };
  // CHANGE 1202077200318274
  // const participantList = (
  //   <div className="assignee-list">
  //     <List
  //       dataSource={availableOperators}
  //       renderItem={(item) => (
  //         <List.Item
  //           className="meeting-events-list-item"
  //           onClick={() => {
  //             handleAddParticipant(item);
  //           }}
  //         >
  //           <div>
  //             {item.firstName} {item.lastName}
  //           </div>
  //         </List.Item>
  //       )}
  //     />
  //   </div>
  // );
  const isEventSameDay = eventStartDate.format(dateFormat) === eventEndDate.format(dateFormat);

  const repeatOptions = (
    <Menu className="menu-show-preview">
      {[
        { name: 'never', label: 'Never' },
        { name: 'everyday', label: 'Every Day' },
        { name: 'weekdays', label: 'Week Days' },
        { name: 'weekends', label: 'Weekends' },
        { name: 'custom', label: 'Custom' },
      ].map((m, i) => {
        return (
          <Menu.Item key={i} className="menu-show-preview" onClick={() => setRepeat(m)}>
            <span>{m.label}</span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const disabledDate = (current) => {
    // Can not select days before today
    //return current && current < eventStartDate.endOf('day').clone().subtract(1, 'days');

    let disable =
      current &&
      (current < eventStartDate.clone().startOf('day') ||
        (repeat.name != 'never' && current > eventStartDate.clone().endOf('day')));

    return disable;
  };

  const disabledDateUntil = (current) => {
    // Can not select days before today
    return current && current < eventStartDate.endOf('day');
  };

  // const updateRepeatingEndDate = (repeat) => {
  //   console.log(repeat);
  //   if (repeat && repeat != 'never') {
  //     //eventEndDate = eventStartDate;
  //   }
  // };

  const colorPicker = <SketchPicker color={eventColor} onChange={(color) => setEventColor(color.hex)} />;

  const handleSubmit = (prop) => {
    props.form.validateFields((err, { title }) => {
      if (!err) {
        console.log(eventMenus);
        console.log(prop);
        setSubmitting(true);
        const resto_id = (JSON.parse(localStorage.getItem('restaurant')) || {}).id;
        const operator = (JSON.parse(localStorage.getItem('operator')) || {}).email;
        const startTimeStamp = moment(`${eventStartDate.format(dateFormat)} ${start}`, 'MM / DD / YYYY hh:mm A');
        let endTimeStamp = moment(`${eventEndDate.format(dateFormat)} ${end}`, 'MM / DD / YYYY hh:mm A');
        endTimeStamp = moment.max(endTimeStamp, startTimeStamp); // event cannot be <0 length
        let untilTimeStamp = repeatUntil
          ? moment(`${repeatUntil.format(dateFormat)}`, 'MM / DD / YYYY').endOf('day')
          : endTimeStamp;

        const eventInfo = {
          color: eventColor,
        };

        if (type === 'meeting') {
          eventInfo.description = eventDescription;
        }

        if (type === 'event') {
          eventInfo.guest = guest;
        }

        // set 'repeat' field to 'never' or 'repeat'
        // and store repeat type/data in info
        let repeat_fieldval = repeat.name === 'never' ? 'never' : 'repeat';

        if (repeat.name != 'never') {
          endTimeStamp = moment.min(endTimeStamp, startTimeStamp.clone().add(1, 'days')); // repeating event cannot be > 1 day in length
          untilTimeStamp = moment.max(untilTimeStamp, endTimeStamp); // event until must be after end of event
          eventInfo.repeat_type = repeat.name;

          if (repeat.name === 'custom') {
            eventInfo.custom_days = selectedCustomDays;
          }
        }

        console.log('Create Event');
        console.log('Repeat: ' + repeat_fieldval);
        console.log('Start: ' + startTimeStamp.format('MM-DD-YYYY H:mm'));
        console.log('  End: ' + endTimeStamp.format('MM-DD-YYYY H:mm'));
        console.log('Until: ' + (repeat_fieldval === 'never' ? 'N/A' : untilTimeStamp.format('MM-DD-YYYY H:mm')));

        const startUnix = startTimeStamp.unix();
        const endUnix = endTimeStamp.unix();
        const untilUnix = repeat_fieldval === 'never' ? null : untilTimeStamp.unix();

        create({
          restaurantId: resto_id,
          name: eventName.trim(),
          startTimestamp: startUnix,
          endTimestamp: endUnix,
          until: untilUnix,
          repeat: repeat_fieldval,
          info: eventInfo,
          type,
          user: operator,
          participants,
          menus: { event_menus: eventMenus },
        })
          .then((result) => {
            if (result) {
              // activateChecklist
              const { id, EventMenus } = result;
              EventMenus.forEach((menu) => {
                const { menuId } = menu;
                activateEventChecklist(menuId, id).then((res) => {
                  console.log('COPIED RECIPE DETAILS TO STATION CHECKLIST');
                });
              });
              // notification.open({
              //   message: 'Successfully Added Event!',
              // });

              showEvent(prop);
            } else {
              console.log('NO RESULT!');
              showEvent(prop);
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
        console.log('CREATED!');
      } else {
        console.log(err);
      }
    });
  };

  const showEvent = (prop) => {
    resetForm();
    setShowDrawer({ type: '', open: false });
    // setHasCreatedEvent(true);
    prop.setHasCreatedEvent = true;
    getCategory();
    addedEvent(true);
    setOperatorsToChoose([]);
    eventSocket.emit('addsEvent', 'addedEvent');
  };

  const getCategory = () => {
    let resto = JSON.parse(localStorage.getItem('restaurant')) || {};
    let params = {
      restaurantId: resto.id,
    };

    searchMenuCategories(params).then((res) => {
      if (res && res.menucategories) {
        console.log('MENU CATS', res.menucategories);
        let classifyCtg = res.menucategories.map((c) => {
          c.type = 'parent';
          c.categoryId = c.id.toString();
          c.id = c.id.toString();
          c.restaurantId = c.restaurantId.toString();
          return c;
        });
        getMenus(classifyCtg, resto.id);
      }
    });
  };

  const getMenus = (cat, restoid) => {
    let getCatIds = cat.map((c) => {
      return c.id;
    });
    console.log('CATIDS', cat, getCatIds);

    searchMenu({ restaurantId: restoid }).then((res) => {
      console.log('GET ALL MENUS', res.menus);
      if (res && res.menus) {
        let allMenus = res.menus.map((m) => {
          m.menuId = m.id.toString();
          m.info = m.info !== 'null' || m.info !== null ? JSON.parse(m.info) : null;
          return m;
        });
        let filterMenuss = allMenus.filter((p) => getCatIds.includes(p.categoryId));
        let filterMenus = filterMenuss.filter((f) => f?.info?.active == true);
        console.log('FILTER MENUS CATID', filterMenus);

        let menuIds = filterMenus.map((f) => f.id);

        console.log('MENUIDS', menuIds);

        batchCourses(menuIds).then((res) => {
          if (res) {
            let allCourses = res.map((c) => {
              return c.MenuCourses;
            });
            console.log('ALL COURSES', allCourses);

            let merged = [].concat.apply([], allCourses);

            console.log(merged);

            let getCourseIds = merged.map((c) => {
              return c.courseId;
            });
            console.log('COURSEIDS++', getCourseIds);

            batchRecipes(getCourseIds).then((res) => {
              let mapRecs = res?.map((f) => {
                return f.CourseRecipes.map((c, i) => ({
                  menuId: res.menuId ? res.menuId : 0,
                  recipes: [{ active: c.active, id: c.recipeId, name: c?.Recipe?.name }],
                  courseId: f.id,
                }));
              });

              let newRecs = [].concat.apply([], mapRecs);

              console.log('NEWRECCSSS!!!', newRecs);

              let combineCourses = merged.concat(newRecs);
              console.log('COMBO MENU-COURSE-RECIPE++++', combineCourses);

              const combResult = Object.values(
                combineCourses.reduce((r, o) => {
                  const key = `${o.courseId}`;

                  if (!r[key]) r[key] = { ...o, recipes: [] };

                  r[key].recipes.push(o.recipes);

                  r[key].recipes = [].concat.apply([], r[key].recipes).filter((u) => u !== undefined && u !== null);

                  return r;
                }, {})
              );

              console.log('ADDED MENUIDS', combResult);

              const comboResult2 = Object.values(
                combResult.reduce((r, o) => {
                  const key = `${o.menuId}`;

                  if (!r[key]) r[key] = { ...o, recipes: [] };

                  r[key].recipes.push(o.recipes);

                  r[key].recipes = [].concat.apply([], r[key].recipes).filter((u) => u !== undefined && u !== null);

                  return r;
                }, {})
              );

              console.log('FINAL COMBO MENU_REC', comboResult2);

              let combined = filterMenus.concat(comboResult2);
              console.log('COMBO', combined);

              //remove event menus from other categories
              let combined2 = combined.filter((e) => !e.info?.originalMenuId);

              const result = Object.values(
                combined2.reduce((r, o) => {
                  const key = `${o.menuId}`;

                  if (!r[key]) r[key] = { ...o, recipes: [] };

                  r[key].recipes.push(o.recipes);

                  r[key].recipes = [].concat.apply([], r[key].recipes).filter((u) => u !== undefined);

                  return r;
                }, {})
              );

              const finalMenus = result.filter((m) => m.id);

              console.log('MENUS WITH RECIPES+++', finalMenus);

              //move event-related menus to its own category

              setMenuList(result);

              let categoryMenus = Object.values(
                finalMenus.reduce((result, { categoryId, id, type, recipes, name, info }) => {
                  if (!result[categoryId])
                    result[categoryId] = {
                      categoryId,
                      menus: [],
                    };
                  result[categoryId].menus.push({
                    categoryId,
                    id,
                    key: id,
                    name,
                    type: 'child',
                    prepped: info,
                    activate: info?.active,
                    recipes: recipes ? recipes : [],
                    activerecipes: recipes ? recipes.filter((r) => r.active == true) : [],
                    assignee: info?.createdBy ? info?.createdBy : '',
                    tags: ['tag 1', 'tag 2', 'tag 3'],
                    texts: 16,
                    attachments: 8,
                    checked: false,
                  });
                  return result;
                }, {})
              );

              console.log(categoryMenus);

              let combinedMenus = cat.concat(categoryMenus);
              console.log('COMBOMENUS', combinedMenus);

              const resultMenus = Object.values(
                combinedMenus.reduce((r, o) => {
                  const key = `${o.categoryId}`;

                  if (!r[key]) r[key] = { ...o, menus: [] };

                  r[key].menus.push(o.menus);

                  r[key].menus = [].concat.apply([], r[key].menus).filter((u) => u !== undefined);

                  return r;
                }, {})
              );

              console.log('MENUS WITH CATEGORIES', resultMenus);

              let tableData = resultMenus.map((m, i) => {
                m.children = m.menus;
                m.menuCount = m.children.filter((d) => d.name !== '');
                m.key = i + 1;
                return m;
              });

              //move event menus to their own category

              const eventMenus = combined.filter((e) => (e.eventName && e.info?.originalMenuId) || e.recipes);

              console.log('EVENTMENUS', eventMenus);

              let newObj = {};

              if (eventMenus && eventMenus.length > 0) {
                //find if category exists
                const uncategorized = cat.find((e) => e.name == 'UNCATEGORIZED');
                console.log('EVENTEXISTS', uncategorized);
                if (!uncategorized) {
                  const eventresult = Object.values(
                    eventMenus.reduce((r, o) => {
                      const key = `${o.menuId}`;

                      if (!r[key]) r[key] = { ...o, recipes: [] };

                      r[key].recipes.push(o.recipes);

                      r[key].recipes = [].concat.apply([], r[key].recipes).filter((u) => u !== undefined);

                      return r;
                    }, {})
                  );

                  const finalEventMenus = eventresult.filter((m) => m.id);

                  console.log('menuList', eventresult);
                  console.log('MENUS WITH RECIPES+++', finalEventMenus);

                  let childMenus = finalEventMenus.map((c) => {
                    c.key = c.id;
                    c.type = 'child';
                    c.prepped = c.info;
                    c.activate = c.info?.active;
                    c.recipes = c.recipes ? c.recipes : [];
                    c.activerecipes = c.recipes ? c.recipes.filter((r) => r.active == true) : [];
                    c.assignee = c.info?.createdBy ? c.info?.createdBy : '';
                    c.tags = c.info?.tags ? c.info?.tags : [];
                    c.texts = 15;
                    c.attachments = 5;
                    c.categorized = 'no';
                    return c;
                  });

                  console.log('EVENTCHILDMENUS', childMenus);

                  newObj.key = cat?.length + 1;
                  newObj.categoryId = 'UNCAT1';
                  newObj.id = 'UNCAT1';
                  newObj.children = childMenus.sort((a, b) => (a.name > b.name ? 1 : -1));
                  newObj.menuCount = childMenus.filter((d) => d.name !== '');
                  newObj.menus = childMenus.filter((d) => d.name !== '');
                  newObj.type = 'parent';
                  newObj.name = 'UNCATEGORIZED';
                }
              }

              console.log('NEWOBJ1', newObj);

              console.log('MENUS WITH CATEGORIES', resultMenus);

              if (Object.keys(newObj).length !== 0) {
                tableData.push(newObj);
              }
              console.log('TABLEDATA', tableData);
              setMenus(tableData);
            });
          }
        });
      } else {
        let noMenus = cat.map((c, i) => {
          c.children = [{ assignee: '', catId: c.categoryId, key: c.categoryId, name: '', tags: [], type: 'child' }];
          c.menuCount = [];
          c.menus = [];
          c.key = i;
          return c;
        });
        setMenus(noMenus);
      }
    });
  };

  const handleRowExpand = (record) => {
    if (expandedRows.includes(record.key)) {
      let filterRecord = expandedRows.filter((key) => key !== record.key);
      setExpandedRows(filterRecord);
    } else {
      setExpandedRows([...expandedRows, record.key]);
    }
  };

  const toggleSelect = (e, obj, status) => {
    console.log(e, obj, status);
    if (status == 'selected') {
      let addSelectedLinks = menus.map((o) => {
        o.children.map((c) => {
          if (obj.id == c.id) {
            c.checked = false;
            o.checkedCount = o.children.reduce((acc, cur) => (cur.checked === true ? ++acc : acc), 0);
          }
          return c;
        });
        return o;
      });
      const clonedEventMenus = cloneDeep(eventMenus);
      let filtered = clonedEventMenus.filter((item) => item.id !== obj.id);
      setEventMenus(filtered);
      setMenus(addSelectedLinks);
    } else {
      let addSelectedLinks = menus.map((o) => {
        o.children.map((c) => {
          if (obj.id == c.id) {
            c.checked = true;
            o.checkedCount = o.children.reduce((acc, cur) => (cur.checked === true ? ++acc : acc), 0);
          }
          return c;
        });
        return o;
      });

      const clonedEventMenus = cloneDeep(eventMenus);
      clonedEventMenus.push(obj);
      setEventMenus(clonedEventMenus);
      setMenus(addSelectedLinks);
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0),
      sortDirections: ['descend', 'ascend'],
      width: 320,
      render: (key, obj, index) => (
        <span style={{ fontFamily: 'Helvetica Neue' }}>
          <span className={obj.type == 'parent' ? '' : 'name-key'}>
            {key && (
              <span className={obj.selected ? 'highlight' : ''}>
                {obj.type == 'child' ? (
                  <span>
                    <span>
                      {obj.checked ? (
                        <span className="checkmark-icon" onClick={(e) => toggleSelect(e, obj, 'selected')}>
                          <CompletionIcon completed={true} dimmed={false} />
                        </span>
                      ) : (
                        <span className="checkmark-icon" onClick={(e) => toggleSelect(e, obj, 'unselected')}>
                          <CompletionIcon completed={false} dimmed={true} />
                        </span>
                      )}
                    </span>
                    <span className="event-folder-icon">
                      <FolderIcon />
                    </span>
                    <span className="menu-Namespan">
                      <span>{key}</span>{' '}
                    </span>
                    <span style={{ fontFamily: 'Helvetica Neue', marginLeft: 15 }}>
                      (
                      {obj.type == 'child' && obj.recipes ? (
                        <span>{`${obj.recipes.length} recipe${obj.recipes.length != 1 ? 's' : ''}`}</span>
                      ) : (
                        ''
                      )}
                      )
                    </span>
                  </span>
                ) : (
                  <span>
                    <span style={{ marginLeft: 15 }}>{key}</span>
                  </span>
                )}
              </span>
            )}{' '}
            {obj.type == 'parent' ? (
              <span className="doc-upload-count" style={{ fontSize: 14 }}>
                ( {obj.checkedCount ? obj.checkedCount : '0'} of{' '}
                {obj.menuCount ? obj.menuCount.length + ' ' + 'menus' : 'no menus'} )
              </span>
            ) : (
              ''
            )}
          </span>
        </span>
      ),
    },
  ];

  useEffect(() => {
    eventSocket2.on('updatedMenu', (message) => {
      let newData = JSON.parse(message);
      console.log('CATUPDATED!!', [newData]);
      setCatgUpdate([newData]);
    });
    eventSocket2.on('addedMenu', (message) => {
      let newData = JSON.parse(message);
      console.log('CATADDED!!', newData);
      setCatgAdd(newData);
    });
    eventSocket2.on('deletedMenu', (message) => {
      let newData = JSON.parse(message);
      console.log('CATDELETED!!', newData.id);
      setCatgDelete(newData.id);
    });
    return () => {
      eventSocket.disconnect();
      eventSocket2.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.keys(catgAdd).length > 0) {
      getCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catgAdd]);

  useEffect(() => {
    if (catgDelete !== '') {
      getCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catgDelete]);

  useEffect(() => {
    if (catgUpdate.length > 0) {
      getCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catgUpdate]);

  return (
    <>
      <Drawer
        width={windowSize.width > 800 ? '500px' : '100%'}
        drawerStyle={{ backgroundColor: 'var(--main-fill)' }}
        placement="right"
        closable={false}
        onClose={() => {
          setShowDrawer({ type: '', open: false });
          resetForm();
          setOperatorsToChoose([]);
        }}
        visible={showDrawer}
      >
        <div className="scroll-div1">
          <>
            <Row gutter={32}>
              <Col className="gutter-row" span={21}></Col>
              <Col className="gutter-row" span={3}>
                <Button
                  className="close-add-event"
                  onClick={() => {
                    setShowDrawer({ type: '', open: false });
                    resetForm();
                    setOperatorsToChoose([]);
                  }}
                  type="primary"
                  shape="circle"
                  size={`small`}
                >
                  <CloseCircleOutlined />
                </Button>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col className="gutter-row" span={12}>
                <span style={{ color: 'var(--base-text)', fontSize: 15 }}>
                  New {type === 'event' ? 'Event' : 'Meeting'}
                </span>
              </Col>
              <Col className="gutter-row" span={12}></Col>
            </Row>
            <Form
              wrapperCol={{ span: 24 }}
              layout="horizontal"
              // initialValues={{ size: componentSize }}
              // onValuesChange={onFormLayoutChange}
              // size={componentSize as SizeType}
            >
              <Row gutter={32}>
                <Col className="gutter-row" span={24}>
                  <Form.Item style={{ color: 'var(--base-text)' }} name="title">
                    <span>Title</span>
                    {getFieldDecorator('title', {
                      rules: [{ required: true, message: 'Title is required' }],
                    })(
                      <input
                        type="text"
                        className="event-name-input"
                        placeholder={`Enter Title`}
                        value={eventName}
                        onChange={(e) => setEventName(e.currentTarget.value)}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={24}>
                  <Popover content={colorPicker} trigger="click" placement="right">
                    <div
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: 4,
                        backgroundColor: eventColor,
                        cursor: 'pointer',
                      }}
                    ></div>
                  </Popover>
                </Col>
                {type === 'event' && (
                  <>
                    <Col className="gutter-row" span={12}>
                      <Form.Item style={{ color: 'var(--base-text)' }}>
                        <span>Guests</span>
                        <input
                          type="number"
                          className="event-name-input"
                          value={guest}
                          onChange={(e) => setGuest(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={24}></Col>
                  </>
                )}
                <Col className="gutter-row" span={12}>
                  <Form.Item style={{ color: 'var(--base-text)' }}>
                    <div>Start</div>
                    <DatePicker
                      getCalendarContainer={(triggerNode) => triggerNode.parentElement}
                      onChange={(e) => {
                        setEventStartDate(e);
                        setEventEndDate(e);
                      }}
                      value={eventStartDate}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                  <Form.Item style={{ color: 'var(--base-text)', paddingTop: 40 }}>
                    <TimePicker
                      getPopupContainer={(trigger) => trigger.parentElement}
                      onChange={(e) => {
                        setStart(e.format(format));
                        setEnd(e.add(2, 'hours').format(format));
                      }}
                      // defaultValue={moment('00:00', format)}
                      value={moment(start, format)}
                      use12Hours
                      minuteStep={5}
                      format={format}
                    />
                  </Form.Item>
                </Col>
                {
                  //repeat.name === 'never' && (
                  <Col className="gutter-row" span={12}>
                    <Form.Item style={{ color: 'var(--base-text)' }}>
                      <div>End</div>
                      <DatePicker
                        getCalendarContainer={(triggerNode) => triggerNode.parentElement}
                        onChange={(e) => setEventEndDate(e)}
                        disabledDate={disabledDate}
                        value={eventEndDate} // {repeat.name === 'never' ? eventEndDate : eventStartDate}
                        format={dateFormat}
                        //disabled={repeat.name != 'never'}
                      />
                    </Form.Item>
                  </Col>
                }
                {
                  //repeat.name === 'never' && (
                  <Col className="gutter-row" span={12}>
                    <Form.Item style={{ color: 'var(--base-text)', paddingTop: 40 }}>
                      <TimePicker
                        getPopupContainer={(trigger) => trigger.parentElement}
                        onChange={(e) => {
                          setEnd(e.format(format));
                        }}
                        // defaultValue={moment('00:00', format)}
                        value={moment(end, format)}
                        use12Hours
                        minuteStep={5}
                        format={format}
                      />
                    </Form.Item>
                  </Col>
                }
                {
                  //isEventSameDay && (
                  <>
                    <Col className="gutter-row" span={12}>
                      <Form.Item style={{ color: 'var(--base-text)' }}>
                        <div>Repeat</div>
                        <Dropdown
                          overlay={repeatOptions}
                          placement="bottomCenter"
                          trigger={['click']}
                          // onChange={(e) => {
                          //   updateRepeatingEndDate(e); does not work
                          // }}
                        >
                          <div className="event-name-input">{repeat.label}</div>
                        </Dropdown>
                      </Form.Item>
                    </Col>
                    {repeat.name != 'never' && (
                      <>
                        <Col className="gutter-row" span={12}>
                          <Form.Item style={{ color: 'var(--base-text)' }}>
                            <div>Until</div>
                            <DatePicker
                              getCalendarContainer={(triggerNode) => triggerNode.parentElement}
                              disabledDate={disabledDateUntil}
                              onChange={(e) => setUntil(e)}
                              defaultValue={eventStartDate}
                              format={dateFormat}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </>
                }
                {isEventSameDay && repeat.name === 'custom' && (
                  <>
                    <Col className="gutter-row" span={24}>
                      <div style={{ color: 'var(--base-text)', fontSize: 15, padding: 10 }}> Repeat Days</div>
                    </Col>
                    {daysOfWeek.map((day) => {
                      return (
                        <Col className="gutter-row" span={12}>
                          <Checkbox
                            className="day-checkbox"
                            checked={checkIfDaySelected(day)}
                            onChange={() => handleAddCustomDay(day)}
                          >
                            {day}
                          </Checkbox>
                        </Col>
                      );
                    })}
                  </>
                )}
                {type === 'meeting' && (
                  <>
                    <Col className="gutter-row" span={24}>
                      <div style={{ color: 'var(--base-text)', fontSize: 15, padding: 10 }}> Participants</div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div className="participant-box">
                        <span className="participant-name">
                          {participants?.length > 0 &&
                            participants.map((participant) => {
                              return (
                                <Tag
                                  color={'black'}
                                  className="tag-participant"
                                  key={`tag-participant-${participant.id}`}
                                  closable={true}
                                  onClose={() => {
                                    const clonedP = cloneDeep(participants);
                                    remove(clonedP, { id: participant.id });
                                    setEventParticipants(clonedP);
                                  }}
                                >
                                  {`${participant.firstName} ${participant.lastName}`}
                                </Tag>
                              );
                            })}
                        </span>
                        {/* CHANGE 1202077200318274 */}
                        <MeetingParticipantAdd
                          participantChoices={operatorsToChoose}
                          participant={searchedParticipant}
                          placeholder={'Add Participant'}
                          onChange={(value) => {
                            handleAddParticipant(JSON.parse(value));
                          }}
                          onSearch={(value) => {
                            setSearchedParticipant(value);
                          }}
                          onClickRemove={() => {
                            onClickRemoveParticipant();
                          }}
                        />
                        {/* <Popover
                          content={participantList}
                          getPopupContainer={(trigger) => trigger.parentElement}
                          overlayStyle={{ marginTop: 5, marginLeft: 0, width: '140px', backgroundColor: '#454545' }}
                          placement="bottom"
                          trigger="focus"
                        >
                          <input
                            type="text"
                            className="participant-input"
                            placeholder="Add Participant"
                            value={searchedParticipant}
                            onChange={(e) => {
                              setSearchedParticipant(e.target.value);
                            }}
                          />
                        </Popover> */}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div style={{ color: 'var(--base-text)', fontSize: 15, padding: 10 }}> Description</div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <TextArea
                        value={eventDescription}
                        onChange={(e) => setEventDescription(e.target.value)}
                        style={{ backgroundColor: 'var(--deep-fill)', color: 'var(--base-text)', border: 0 }}
                        className="textarea-inputs"
                        rows={5}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Row gutter={32}>
                {type === 'event' && (
                  <>
                    {/* <Col className="gutter-row" span={8}>
                      <div className="event-menu-list">
                        <div>{'Select menus'}</div>
                      </div>
                    </Col>
                    <Col className="gutter-row" span={1}>
                      <Dropdown overlay={menuListItem} trigger={['click']}>
                        <div className="dropdown-icon-menu">
                          <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        </div>
                      </Dropdown>
                    </Col> */}
                    {/* <Col className="gutter-row" span={15}></Col>
                    <Col className="gutter-row" span={8}></Col> */}
                    {/* <Col className="gutter-row" span={24}>
                      <br />
                      <br />
                      <div className="meeting-reminders-future-title">Event Menus</div>
                      <div className="meeting-events-panel-display">
                        <List
                          dataSource={eventMenus}
                          renderItem={(item) => (
                            <List.Item className="meeting-events-list-item">
                              <div>
                                <span className="list-bullet"></span>
                                {item.name}
                              </div>
                            </List.Item>
                          )}
                        />
                      </div>
                    </Col> */}
                    <br />
                    <div className="meeting-reminders-future-title" style={{ marginLeft: 10 }}>
                      Selected ({eventMenus && eventMenus.length > 0 ? eventMenus.length : 0})
                    </div>
                    <br />
                    <div>
                      {eventMenus &&
                        eventMenus.length > 0 &&
                        eventMenus.map((e) => {
                          return (
                            <div>
                              <div style={{ display: 'flex', color: 'var(--base-text)' }}>
                                <span className="event-folder-selected-icon">
                                  <FolderIcon />
                                </span>
                                {/* <Link target="_blank" to={`/menu/${e.id}`}> */}
                                <div className="menu-Namespan" style={{ marginLeft: 5, marginTop: 5 }}>
                                  {/* <span>{key}</span>{' '} */}
                                  {e.name}
                                </div>
                                {/* </Link> */}
                                {e.recipes && e.recipes.length > 0 && (
                                  <div style={{ fontFamily: 'Helvetica Neue', marginLeft: 15, marginTop: 7 }}>
                                    (<span>{`${e.recipes.length} recipe${e.recipes.length != 1 ? 's' : ''}`}</span>)
                                  </div>
                                )}
                              </div>
                              <hr className="doc-line3" />
                            </div>
                          );
                        })}
                    </div>

                    {menus.length > 0 && !showMenus && (
                      <LinkButton
                        className="button-link-replacement event-menu-add"
                        alt="add menu"
                        onClick={() => {
                          setShowMenus(true);
                        }}
                      >
                        Add menu
                      </LinkButton>
                    )}
                    <br />
                    <br />
                    {showMenus && (
                      <div>
                        <div className="meeting-reminders-future-title" style={{ marginLeft: 10 }}>
                          Select menu
                        </div>
                        <div>
                          <Table
                            columns={columns}
                            dataSource={menus}
                            rowClassName={(record, index) => (record.type == 'parent' ? 'parent' : 'child')}
                            pagination={false}
                            onExpand={(expanded, record) => handleRowExpand(record)}
                            expandedRowKeys={expandedRows}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={8}></Col>
                <Col className="gutter-row" span={8}></Col>
                <Col className="gutter-row" span={8}>
                  <button className="add-event-btn" htmltype="submit" onClick={handleSubmit}>
                    {isSubmitting ? <Spin /> : type === 'event' ? 'Add Event' : 'Add Meeting'}
                  </button>
                </Col>
              </Row>
            </Form>
          </>
        </div>
      </Drawer>
    </>
  );
};

export default Form.create()(AddEventDrawerV2);
